import { REGEX } from 'constants/common';

export const getStringFiller = (text: string | null, filler = '-') => {
  if (!text || text.length === 0) {
    return filler;
  }
  return text;
};

export const camelCaseToTitleCase = (text: string) => {
  const result = text.replace(/([A-Z])/g, ' $1');
  return result.charAt(0).toUpperCase() + result.slice(1);
};

export const isValidEmail = (email: string) => {
  const trimmedEmail = email?.trim();
  if (REGEX.email.test(trimmedEmail) || trimmedEmail.length === 0) {
    let isValid = true;
    const inValidDomains = ['..', '.con', '.comn', '.cok', '.don', '.cim', 'gnail.com', 'gmal.com'];
    inValidDomains.map(_ => {
      if (email.endsWith(_)) {
        isValid = false;
      }
    });
    return isValid;
  }
  return false;
};

export const isFacebookLinkValid = (facebookLink: string) => {
  return REGEX.facebookLinkRegex.test(facebookLink) || facebookLink.length === 0;
};

export const isYelpLinkValid = (yelpLink: string) => {
  return REGEX.yelpLinkRegex.test(yelpLink) || yelpLink.length === 0;
};

export const isWebsiteValid = (website: string) => {
  return REGEX.websiteRegex.test(website) || website.length === 0;
};

export const isPhoneNumberValid = (phoneNumber: string) => {
  return REGEX.phoneNumber.test(phoneNumber) || phoneNumber.length === 0;
};

export const filterEnglishOnly = (input: string): string => {
  if (!input || input.length === 0) return input;

  // Remove any characters that are not ASCII (0-127) using replace
  // eslint-disable-next-line no-control-regex
  return input.replace(/[^\x00-\x7F]/g, '');
};

export const TEAM_NAME_MIN_LENGTH = 2;
export const TEAM_NAME_MAX_LENGTH = 300;

// Unicode control characters (C0 + C1), including \n, \t, \r
// eslint-disable-next-line no-control-regex
const CONTROL_CHARS_REGEX = /[\u0000-\u001F\u007F-\u009F]/;

export const TEAM_LABEL_MAX_LENGTH = 50;

export const getTeamLabelValidationError = (label: string | null | undefined): string | null => {
  const value = label ?? '';

  // Optional field: blank is always valid and clears any stored value.
  if (!value.trim()) {
    return null;
  }

  if (value.trim().length > TEAM_LABEL_MAX_LENGTH) {
    return `Label must be ${TEAM_LABEL_MAX_LENGTH} characters or less`;
  }

  if (value.includes('<') || value.includes('>')) {
    return 'Label cannot contain < or >';
  }

  if (CONTROL_CHARS_REGEX.test(value)) {
    return 'Label cannot contain special characters like new lines or tabs';
  }

  return null;
};

export const getTeamNameValidationError = (teamName: string | null | undefined): string | null => {
  const value = teamName ?? '';
  const trimmed = value.trim();

  if (!trimmed) {
    return 'Please enter your team name';
  }

  if (trimmed.length < TEAM_NAME_MIN_LENGTH) {
    return 'Team name must be between 2 and 300 characters';
  }

  if (trimmed.length > TEAM_NAME_MAX_LENGTH) {
    return 'Team name must be between 2 and 300 characters';
  }

  if (value.includes('<') || value.includes('>')) {
    return 'Team name cannot contain < or >';
  }

  if (CONTROL_CHARS_REGEX.test(value)) {
    return 'Team name cannot contain special characters like new lines or tabs';
  }

  return null;
};
